import type { TourProps } from 'antd'
import { z } from 'zod'

export const tourSequence = [
  'app-shell-intro',
  'home-intro',
  'orders-stock',
  'orders-table',
  'patients-list',
  'patient-edit',
  'patient-overview',
  'patient-cost-carriers',
  'home-outro',
] as const

export type TourId = (typeof tourSequence)[number]

export type AntdTourStep = NonNullable<TourProps['steps']>[number]

export type TourStep = AntdTourStep & {
  onEnter?: () => void | Promise<void>
}

export const tourSearchSchema = z.object({
  tour: z.enum(tourSequence).optional(),
  tourStep: z.coerce.number().int().min(0).optional(),
})

export type TourSearch = z.infer<typeof tourSearchSchema>
